/* eslint-disable no-console */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useContext, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import NewTable from "../../../member/components/Newtable/NewTable";
import styles from "./EmailerTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import Button from "../../../../components/common/Button";
import Loader from "../../../../components/common/Loader/Loader";
import { AlertStatus } from "../../../../contants";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { ROUTES } from "../../../../utils/constants";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import Emailer from "../../../../services/api/emailer";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = ({
  searchData,
  currentPage,
  pageSize,
  showStatusColumn,
  selectedItems,
  toggleItemSelection,
  selectAll,
}) =>
  searchData.map((friendInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    const isSelected = selectAll || selectedItems.includes(friendInfo.id);

    const handleCheckboxClick = () => {
      toggleItemSelection(friendInfo.id);
    };
    return (
      <TableRow
        // style={tableStyle.tableRow}
        key={friendInfo.id}
        selected={isSelected}
        onClick={() => handleCheckboxClick()}
      >
        <TableCell style={tabelCellWidth.medium}>
          <Checkbox checked={isSelected} />
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo?.id ?? friendInfo.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.fullName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.divisionName || "NA"} / ${
                friendInfo?.subDivisionName || "NA"
              }`}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.orgStructure.areaName || "NA"} / ${
                friendInfo?.orgStructure.clusterName || "NA"
              } / ${friendInfo?.orgStructure.zoneName || "NA"} / ${
                friendInfo?.orgStructure.regionName || "NA"
              } / ${friendInfo?.orgStructure.chapterName || "NA"} / ${
                friendInfo?.orgStructure.districtName || "NA"
              }`}
            </Typography>{" "}
          </div>
        </TableCell>
        {showStatusColumn && (
          <>
            {/* <TableCell style={tabelCellWidth.medium}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.mobileNumber || "-"}{" "}
                </Typography>
              </div>
            </TableCell> */}
            {/* <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {`${friendInfo?.address.addressLine || "-"} / ${
                    friendInfo?.address.cityName || "-"
                  } / ${friendInfo?.address.stateName || "-"}`}
                </Typography>{" "}
              </div>
            </TableCell> */}
          </>
        )}
      </TableRow>
    );
  });

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  // hasPermission,
  showStatusColumn,
  user,
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const templateInfo = useSelector((state) => state.templateInfo.templateInfo);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();

  const handleSelectAllClick = () => {
    setSelectAll(!selectAll);
  };

  const toggleItemSelection = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  const handleSendEmail = async () => {
    const queryParams = new URLSearchParams(location.search);
    try {
      // mainlinePositionIds
      const mainlinePositionIdsQueryParam = queryParams.get(
        "mainlinePositionIds"
      );
      const mainlinePositionIds = mainlinePositionIdsQueryParam
        ? mainlinePositionIdsQueryParam
            ?.split(",")
            ?.map((id) => parseInt(id, 10))
            ?.filter(Boolean)
        : [];

      // dualPositionIds
      const dualPositionIdsQueryParam = queryParams.get("dualPositionIds");
      const dualPositionIds = dualPositionIdsQueryParam
        ? dualPositionIdsQueryParam
            .split(",")
            .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];
      // gohonzonTypes
      const gohonzonTypesQueryParam = queryParams.get("gohonzonTypes");
      const gohonzonTypes = gohonzonTypesQueryParam
        ? gohonzonTypesQueryParam
            .split(",")
            // .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];
      // dateOfJoiningFrom
      const dateOfJoiningFromQueryParam = queryParams.get("dateOfJoiningFrom");
      const dateOfJoiningFrom = dateOfJoiningFromQueryParam
        ? moment(dateOfJoiningFromQueryParam, "DD-MMM-YYYY").format(
            "YYYY-MM-DD"
          )
        : "";
      // dateOfJoiningTo
      const dateOfJoiningToQueryParam = queryParams.get("dateOfJoiningTo");
      const dateOfJoiningTo = dateOfJoiningToQueryParam
        ? moment(dateOfJoiningToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateOfBirthFrom
      const dateOfBirthFromQueryParam = queryParams.get("dateOfBirthFrom");
      const dateOfBirthFrom = dateOfBirthFromQueryParam
        ? moment(dateOfBirthFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateOfBirthTo
      const dateOfBirthToQueryParam = queryParams.get("dateOfBirthTo");
      const dateOfBirthTo = dateOfBirthToQueryParam
        ? moment(dateOfBirthToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";
      // conferralDateFrom
      const conferralDateFromQueryParam = queryParams.get("conferralDateFrom");
      const conferralDateFrom = conferralDateFromQueryParam
        ? moment(conferralDateFromQueryParam, "DD-MMM-YYYY").format(
            "YYYY-MM-DD"
          )
        : "";
      // conferralDateTo
      const conferralDateToQueryParam = queryParams.get("conferralDateTo");
      const conferralDateTo = conferralDateToQueryParam
        ? moment(conferralDateToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";
      // appointedAtFrom
      const appointedAtFromQueryParam = queryParams.get("appointedAtFrom");
      const appointedAtFrom = appointedAtFromQueryParam
        ? moment(appointedAtFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // appointedAtTo
      const appointedAtToQueryParam = queryParams.get("appointedAtTo");
      const appointedAtTo = appointedAtToQueryParam
        ? moment(appointedAtToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";
      setIsLoading(true);
      let payload;
      if (selectAll) {
        payload = {
          id: queryParams.get("id") || null,
          // ids: [],
          fullName: queryParams.get("fullName") || null,
          emailId: queryParams.get("emailId") || null,
          mobileNumber: queryParams.get("mobileNumber") || null,
          address: queryParams.get("address") || null,
          divisionId: queryParams.get("divisionId") || null,
          subDivisionId: queryParams.get("subdivisionId") || null,
          dateOfJoiningFrom: dateOfJoiningFrom || null,
          dateOfJoiningTo: dateOfJoiningTo || null,
          dateOfBirthFrom: dateOfBirthFrom || null,
          dateOfBirthTo: dateOfBirthTo || null,
          cityId: queryParams.get("cityId") || null,
          stateId: queryParams.get("stateId") || null,
          professionIds: queryParams.get("professionsId") || null,
          status: null,
          areaId: queryParams.get("areaId") || null,
          clusterId: queryParams.get("clusterId") || null,
          zoneId: queryParams.get("zoneId") || null,
          regionId: queryParams.get("regionId") || null,
          chapterId: queryParams.get("chapterId") || null,
          districtId: queryParams.get("districtId") || null,
          blockId: queryParams.get("blockId") || null,
          gohonzonTypes: gohonzonTypes || null,
          conferralDateFrom: conferralDateFrom || null,
          conferralDateTo: conferralDateTo || null,
          mainlinePositionIds: mainlinePositionIds || null,
          dualPositionIds: dualPositionIds || null,
          appointedAtFrom: appointedAtFrom || null,
          appointedAtTo: appointedAtTo || null,
          contactType: user || null,
        };
      } else {
        payload = {
          ids: selectedItems,
        };
      }

      const response = await Emailer.addRecipients({
        data: payload,
        templateId: templateInfo.id,
      });
      if (response.code === 200) {
        toast.show("Recipient added Successfully", AlertStatus.SUCCESS);
        navigate(ROUTES.EMAILER_TEMPLATES.path);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      displayName: (
        <Checkbox checked={selectAll} onChange={handleSelectAllClick} />
      ),
      key: "selectMembers",
    },
    {
      displayName: "S.No",
      key: "s.no",
    },
    {
      displayName: "Member ID",
      key: "id",
    },
    {
      displayName: "Name",
      key: "fullName",
    },
    {
      displayName: "Division/Sub Division",
      key: "division",
    },
    {
      displayName: "Org Structure",
      key: "orgstructure",
    },
  ];

  return (
    <div style={styles.container}>
      {/* <Box style={styles.recipientsContainer}>
        <p style={styles.recipientsContainerText}>
          {`Template Name: ${templateInfo?.templateName || "NA"}`}
        </p>
      </Box> */}
      <Box style={styles.recipientsContainer}>
        {/* <p>Selected Receipients: {selectedItems}</p> */}
        <Box sx={{ flexGrow: "1" }}>
          <p
            style={{ ...styles.ellipsisText, width: "50%" }}
          >{`Template Name: ${templateInfo?.templateName || "NA"}`}</p>
          {selectAll ? (
            <p style={styles.recipientsContainerText}>
              Selected Recipients: All
            </p>
          ) : (
            <p
              style={
                selectedItems.length > 5
                  ? styles.ellipsisText
                  : styles.recipientsContainerText
              }
            >
              Selected Recipients:{" "}
              {selectedItems.length <= 5
                ? selectedItems.slice(0, 5).join(",")
                : `${selectedItems.slice(0, 5).join(", ")}...`}
            </p>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            style={{ ...CommonStyles.buttonStyle, width: "150px" }}
            label="Add Recipients"
            onClick={handleSendEmail}
            disabled={!selectAll && selectedItems.length === 0}
          />
        </Box>
      </Box>
      <NewTable
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          // hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          selectedItems,
          toggleItemSelection,
          selectAll,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{ ...styles.tableHeadCells, textAlign: "center" }}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default ReportTable;
